<template>
    <div class="app-collection-list">
        <div class="row">
            <div 
            v-for="collection in filteredCollections"
            :key="collection.id"
            class="col-md-6 pl-3 pr-3 pt-3 mb-4"
            :class="{ 'col-lg-3' : compact, 'col-lg-4' : !compact}"
            >
                <router-link :to="{ name: 'collection', params: {cid: collection.id}}">
                <div class="cbox rounded shadow-sm hover-shadow">
                    <div class="body" :style="getPoster(collection.poster)"></div>
                    <div class="title p-2">
                        <strong>{{collection.title}}</strong>
                        <span v-if="isNew(collection)" class="small float-right status-label mr-1">
                            New!
                        </span>
                        <span v-else-if="isUpdated(collection)" class="small float-right status-label updated mr-1">
                            Updated!
                        </span>
                        <span v-else-if="isPremium(collection)" class="small float-right status-label premium mr-1">
                            Premium
                        </span>
                        <span v-else class="text-muted small mt-1 float-right">{{getCount(collection.id)}} Gradients</span>
                    </div>
                </div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import gradients from '@/util/gradients.js'
import collections from '@/util/collections.js'

const NUM_DAYS_NEW = 30;
const NUM_DAYS_UPDATED = 30;

export default {
  name: 'home',
  components: {
  },
  props: {
      collectionType: String,
      max: {
          type: Number,
          required: false
      },
      cat: {
          type: String,
          required: false
      },
      compact: {
          type: Boolean,
          required: false,
          default: false,
      }
  },
  methods: {
    isNew(collection){
        let now = (new Date()).getTime();
        let difference = now - collection.created;
        if(difference < (NUM_DAYS_NEW * 24 * 60 * 60 * 1000)) return true;
        return false;
    },
    isUpdated(collection){
        let now = (new Date()).getTime();

        for(let i = 0; i< gradients.length; i++){
            if(gradients[i].tags.includes(collection.id)){
                let difference = now - gradients[i].date
                if(difference < (NUM_DAYS_UPDATED * 24 * 60 * 60 * 1000)) return true;
            }
        }
        return false;
    },
    isPremium(collection){
        return collection.premium;
    },
    getPoster(gid){
        let gradient = gradients.find((obj) => {
            return obj.date == gid;
        });

        if(gradient.content.indexOf('background-image') != -1){
            return gradient.content; // Already has full CSS styles
        }
        else {
            return `background-image: ${gradient.content};`
        }
    //   return gradient.content;
    },
    getCount(cid){
      return gradients.reduce((acc, curr) => {
        if(curr.tags.includes(cid)) return acc + 1;
        return acc;
      }, 0);
    },
    gotoCollection(cid){
      this.$router.push({ name: 'collection', params: {cid}})
    }
  },
  computed: {
    selectedCollections(){
        if (this.collectionType == 'ALL'){
            return collections.sort((c1,c2) => {
                return c1.created - c2.created;
            });
        }
        else if(this.collectionType == 'CREATED'){
            return collections.sort((c1,c2) => {
                return c2.created - c1.created;
            });
        }
        else if(this.collectionType == 'POPULAR'){
            return collections.sort((c1,c2) => {
                return c2.popularity - c1.popularity
            });
        }
        else if(this.collectionType == 'PREMIUM'){
            return collections
            .filter((c) => c.premium )
        }
        else if(this.collectionType == 'RANDOM'){
            return collections
            .map((a) => ({ sort: Math.random(), value: a}))
            .sort((a,b) => a.sort - b.sort)
            .map((a) => a.value);
        }
        else if(this.collectionType == 'UPDATED'){
            collections.forEach((col) => {
                col.updated = 0;
                gradients.forEach((grad) => {
                    if(grad.tags.includes(col.id) && grad.date > col.updated) col.updated = grad.date;
                });
            });

            return collections.sort((c1,c2) => {
                return c2.updated - c1.updated
            });
        }
        else if (this.collectionType == 'CATEGORY'){
            return collections.filter((col) => {
                if(col.categories.includes(this.cat)) return true;
                return false;
            }).sort((c1,c2) => {
                return c2.created - c1.created;
            });
        }
        else if (this.collectionType == 'FEATURED'){
            return collections.filter((col) => {
                if(col.categories.includes('featured')) return true;
                return false;
            })
        }

        return collections
    },
    filteredCollections(){
        if(!this.max) return this.selectedCollections;
        else {
            return this.selectedCollections.filter((element, index) => {
                return index < this.max
            })
        }
    }
  }
}
</script>

<style lang="scss">
.app-collection-list {
    a, a:hover {
        text-decoration: none;
    }
  .cbox {
    $bradius: 4px;
    cursor: pointer;
    transition: .6s all;
    // box-shadow: 10px 5px 5px red;
    .body {
        border-top-left-radius: $bradius;
        border-top-right-radius: $bradius;        
        height: 175px;
        background-color: green;
    }
    .title {
        border-bottom-left-radius: $bradius;
        border-bottom-right-radius: $bradius;
        background: white;
        text-align: left;
        color: rgb(44, 62, 80);
    }
    .status-label {
        background: #ec0505;
        color:white;
        padding: 2px 8px;
        font-weight: bold;
        border-radius: 4px;
    }
    .premium {
        background-color: $cta-color;
        color: $dark;
        font-weight: normal;
    }
  }
}
</style>